import _ from 'lodash';

const statesToParams = st => _.join(st, ',');

export default function fetchStatesGeography(selectedStates, placePath) {
  const states = statesToParams(selectedStates);
  const url = `https://geo.uniteusdev.com/v1/${placePath}?states=${states}`;

  const http = new XMLHttpRequest();
  return new Promise((resolve, reject) => {
    http.onreadystatechange = () => {
      if (http.readyState === 4) {
        const resp = JSON.parse(http.responseText);
        if (resp.error) {
          reject(resp.error);
        } else {
          resolve(resp);
        }
      }
    };
    http.open('GET', url);
    http.send();
  });
}



// WEBPACK FOOTER //
// ./public/js/actions/fetchStatesGeography.js